import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateRealEstateMortgage.json';
import FormError from '../../../../view/FormError';
import Meta from '../../../../model/Meta';

class RealEstateMortgageStep5 extends Component {
    constructor(props) {
        super(props);

        this.state = Data;

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));

					// Initialize errors and callbacks
					this.errorHandle();

				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(e, radioname=null) {

		/**
		 * Passing name props for radio buttons
		 * Having issues with radio buttons when in array map
         * @ radioname String
		 */		
		const target = e.target;
		const value = target.value;
		const name = radioname ? radioname : target.name;

		this.setState({
			details: {
				property: {
                    ...this.state.details.property,
                    [name]: value
                },
				mortgagor: this.state.details.mortgagor,
				mortgagee: this.state.details.mortgagee
			},
			formFocus: `property_${name}`
		},
			()=>{
				//console.log("Handle user change: ", this.state);
				console.log("Focus target: ", this.state.formFocus+value);
				this.setState(this.state);
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				this.errorHandle();

			}
		);
	}
    
    errorHandle(callback = null) {
        let errorArray = [];

        if(
            !this.state.details.property.requireFireInsurance ||
            !this.state.details.property.registerMortgage ||
            !this.state.details.property.paymentFees ||
            !this.state.details.property.paymentDefault
            ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
        } 

        ////console.log("Going to state: ", errorArray)
        this.setState({
            formError: errorArray
        },(i)=>{
            ////console.log("Error handle: ", this.state )
            localStorage.setItem(this.state.formId, JSON.stringify(this.state));
            this.checkCompleteness();	
            this.elementsShowHide();	
        })

    }

    checkCompleteness() {

		if(this.state.formError.length>0) {
            $(".next").addClass("disabled");
            $(".form-error").removeClass("d-none");
		} else {
            $(".next").removeClass("disabled");
            $(".form-error").addClass("d-none");
		}
			
    }

    elementsShowHide() {
        this.state.details.property.hasBroker==="No" ?
            $(".property-broker-commission").addClass("d-none") :
            $(".property-broker-commission").removeClass("d-none");
    }

    render() {
        const meta = {
			title: "Insurance Information - Real Estate Mortgage Contract",
			description: "Enter insurance information to create your custom Real Estate Mortgage Contract"
		}
        return (
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((5/6)*100)} />

                                <form>

                                    <br />

                                    <div className="requireFireInsurance">
                                        <p className="label"><strong>Will a fire insurance over the mortgaged property be required from the mortgagor?<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="Yes" 
                                                            onChange={(e)=>this.handleChange(e, "requireFireInsurance")}
                                                            checked={this.state.details.property.requireFireInsurance === 'Yes'} 
                                                        />
                                                            Yes
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="No" 
                                                            onChange={(e)=>this.handleChange(e, "requireFireInsurance")}
                                                            checked={this.state.details.property.requireFireInsurance === 'No'} 
                                                        />
                                                            No
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="registerMortgage">
                                        <p className="label"><strong>Will the mortgage be registered before the Register of Deeds? This means that the mortgage will be annotated on the title of the subject real property.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="Yes" 
                                                            onChange={(e)=>this.handleChange(e, "registerMortgage")}
                                                            checked={this.state.details.property.registerMortgage === 'Yes'} 
                                                        />
                                                            Yes
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="No" 
                                                            onChange={(e)=>this.handleChange(e, "registerMortgage")}
                                                            checked={this.state.details.property.registerMortgage === 'No'} 
                                                        />
                                                            No
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>      

                                    <div className={this.state.details.property.registerMortgage==="Yes"?``:`d-none`}><br />
                                        <p className="label"><strong>Who will pay for the registration fee?<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="Mortgagor" 
                                                            onChange={(e)=>this.handleChange(e, "registerMortgageBy")}
                                                            checked={this.state.details.property.registerMortgageBy === 'Mortgagor'} 
                                                        />
                                                            Mortgagor
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="Mortgagee" 
                                                            onChange={(e)=>this.handleChange(e, "registerMortgageBy")}
                                                            checked={this.state.details.property.registerMortgageBy === 'Mortgagee'} 
                                                        />
                                                            Mortgagee
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="paymentFees">
                                        <p className="label"><strong>Who will pay for the documentary stamp tax, notarial fee and other necessary expenses?<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="Mortgagor" 
                                                            onChange={(e)=>this.handleChange(e, "paymentFees")}
                                                            checked={this.state.details.property.paymentFees === 'Mortgagor'} 
                                                        />
                                                            Mortgagor
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="Mortgagee" 
                                                            onChange={(e)=>this.handleChange(e, "paymentFees")}
                                                            checked={this.state.details.property.paymentFees === 'Mortgagee'} 
                                                        />
                                                            Mortgagee
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="paymentDefault">
                                        <p className="label"><strong>How many consecutive amortizations/installments should the mortgagee fail to pay to be considered in breach of the agreement?<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-4">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="1" 
                                                            onChange={(e)=>this.handleChange(e, "paymentDefault")}
                                                            checked={this.state.details.property.paymentDefault === '1'} 
                                                        />
                                                            1
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="2" 
                                                            onChange={(e)=>this.handleChange(e, "paymentDefault")}
                                                            checked={this.state.details.property.paymentDefault === '2'} 
                                                        />
                                                            2
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="3" 
                                                            onChange={(e)=>this.handleChange(e, "paymentDefault")}
                                                            checked={this.state.details.property.paymentDefault === '3'} 
                                                        />
                                                            3
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="4" 
                                                            onChange={(e)=>this.handleChange(e, "paymentDefault")}
                                                            checked={this.state.details.property.paymentDefault === '4'} 
                                                        />
                                                            4
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="5" 
                                                            onChange={(e)=>this.handleChange(e, "paymentDefault")}
                                                            checked={this.state.details.property.paymentDefault === '5'} 
                                                        />
                                                            5
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="6" 
                                                            onChange={(e)=>this.handleChange(e, "paymentDefault")}
                                                            checked={this.state.details.property.paymentDefault === '6'} 
                                                        />
                                                            6
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                </form>

                                {/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 5/6</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath+"/4"} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/6"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>

                            </div>
                            
                            <div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default RealEstateMortgageStep5;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/real-estate-mortgage/RealEstateMortgageStep5.js